// extracted by mini-css-extract-plugin
module.exports = {"ExpandMenuHeader":"ExpandMenuHeader___15POV","ExpandMenu":"ExpandMenu___356zE","switchLocalButton":"switchLocalButton___RZ0Zv"};